import { Injectable, Pipe, PipeTransform, signal, effect } from "@angular/core";
import { md5 } from "./md5.service";
// import { ToasterService } from "../shared/toaster/toaster.service";
import { localStorageService } from "./localstorage.service";
import { Subject } from "rxjs";
import { ToasterService } from "../shared/toaster/toaster.service";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import Clarity from '@microsoft/clarity';
import { IntercomService } from "./intercom.service";


declare let Stripe: any;

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public country_data = signal<any>({});
  showNotificationBar:boolean = false
  // this element used to create stripe element from stripe key.
  public stripeElement: any;
  unread_count: number = 0;
  public dateFormating: any = {
    US: {
      specialCharacters: ['/'],
      fieldOrder: [{
        key: 'month',
        placeholder: 'MM'
      },
      {
        key: 'day',
        placeholder: 'DD'
      },
      {
        key: 'year',
        placeholder: 'YYYY'
      },]
    },
    CA: {
      formatting: '0000-M0-d0',
      placeHolder: 'YYYY-MM-DD',
      specialCharacters: ['-'],
      fieldOrder: [
        {
          key: 'year',
          placeholder: 'YYYY'
        },
        {
          key: 'month',
          placeholder: 'MM'
        },
        {
          key: 'day',
          placeholder: 'DD'
        }
      ]
    },
    GB: {
      // formatting: 'd0/M0/0000',
      // placeHolder: 'DD/MM/YYYY',
      specialCharacters: ['/'],
      fieldOrder: [
      {
        key: 'day',
        placeholder: 'DD'
      },
      {
        key: 'month',
        placeholder: 'MM'
      },
      {
        key: 'year',
        placeholder: 'YYYY'
      }
    ]
    },
    AU: {
      formatting: 'd0-M0-0000',
      placeHolder: 'DD-MM-YYYY',
      specialCharacters: ['-']
    },
    NZ: {
      formatting: 'd0/M0/0000',
      placeHolder: 'DD/MM/YYYY',
      specialCharacters: ['/']
    },
    FR: {
      formatting: 'd0/M0/0000',
      placeHolder: 'DD/MM/YYYY',
      specialCharacters: ['/']
    },
    DE: {
      formatting: 'd0.M0.0000',
      placeHolder: 'DD.MM.YYYY',
      specialCharacters: ['.']
    },
    IT: {
      formatting: 'd0/M0/0000',
      placeHolder: 'DD/MM/YYYY',
      specialCharacters: ['/']
    },
    JP: {
      formatting: '0000/M0/d0',
      placeHolder: 'YYYY/MM/DD',
      specialCharacters: ['/']
    },
    PL: {
      formatting: 'd0.M0.0000',
      placeHolder: 'DD.MM.YYYY',
      specialCharacters: ['.']
    },
    ES: {
      formatting: 'd0-M0-0000',
      placeHolder: 'DD-MM-YYYY',
      specialCharacters: ['-']
    },
  };

  public trainingFromType = {
    dashboard: 'dashboard',
    helpCenter: 'helpCenter',
    scheduleNow: 'scheduleNow'
  }
  public contractType: any = {
    6: 'Protected Ez Plan',
    2: 'Protected No Fee'
  }

  public downloadType = {
    DOWNLOAD: 0,
    PRINT: 2
  }

  public defferedMonths = 12;

  public contractTypes = {
    noFee: 2,
    ez_with_deffered: 6
  };

  public stripeKey = signal<any>('');
  public language_data = signal<languageData[]>([]);

  public country_currency_info = signal<country_currency_info>({});
  public search_emitter = new Subject<any>();
  public stripe_data = signal<any | null>(null);

  public bank_details = signal<bank_details>({
    bank_name: '',
    routing_number: '',
    account_number: '',
    account_holder_name: '',
    account_holder_type: '',
  });
  public card_details = signal<card_details>({
    brand: '',
    fingerprint: '',
    last4: '',
    source_id: 0,
    date_added: ''
  });

  public auth_docs = signal<any>({});
  public debt_owed_duration_and_discount = signal<any>({});
  public identity_status = signal<any>({});
  public doctorSettings = signal<any>({});
  public authenticateApiResponse = signal<any>({});

  public sideMenus = signal<menu[]>([]);
  public showTraining = signal<any>({});
  public doctorProfile = signal<userProfile>({
    doctor_email: '',
    doctor_name: '',
    business_verification_state: '',
    google_id: '',
    agent_email: '',
  });

  public paymentSourceType = {
    CARD: 3,
    DEBIT_CARD: 2,
    BANK: 1,
    WALLET: 4,
    GPAY:1,
    APPLEPAY:2
  }

  public paymentMode = {
    BUSINESS: 2,
    CUSTOMER: 1
  }

  key_sort_by: any;
  signaturePadBase64 = '';
  
  identityStatus = {
    verified: 'identity_verified'  ,
    business_verified:'business_verified',
    unverified: 'unverified',
    processing:'verification_processing',
    pending:'verification_pending'
  }
  public dynamicColorBgStyle = [
    { bg: '#E1FDF3', color: '#0F6648' },
    { bg: '#FFC737', color: '#000' },
    { bg: '#FFEFF0', color: '#76012C' },
    { bg: '#E1FDF3', color: '#18B557' },
    { bg: '#f0f0f0', color: '#0F6648' },
    { bg: '#eaf2ff', color: '#0F6648' },
    { bg: '#f8e7dc', color: '#0F6648' },
    { bg: '#f0ffe0', color: '#0F6648' },
    { bg: '#fff0f5', color: '#0F6648' },
  ];

  randomIndex = Math.floor(Math.random() * (this.dynamicColorBgStyle.length - 1));

  socketIds = {
    START_LOADING: 'START_LOADING',
    STOP_LOADING: 'STOP_LOADING',
    DOCTOR_CONNECTED: 'DOCTOR_CONNECTED',
    DOCTOR_LOGOUT: 'DOCTOR_LOGOUT',
    CONTINUE_FINANCE_ON_BUSINESS: 'CONTINUE_FINANCE_ON_BUSINESS'
  };

  risk_type = {
    HIGH_RISK_FINANCING: 'HIGH_RISK_FINANCING',
    SECURE_FINANCING: 'SECURE_FINANCING',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE'
  }

  
  public customDateInputType = {
    DOB: 'DOB',
    CUSTOMDATE: 'CUSTOMDATE'
  }
  public epoch = new Date().getFullYear();
  constructor( private _local: localStorageService, private _toaster: ToasterService, private intercomService: IntercomService) {
    effect(() => {
      const stripeKey = this.stripeKey();
      if (stripeKey) {
        this.stripeElement = Stripe(stripeKey);
      }
    });
  }
  doctorProfileImage = ''
  dispute_count:number = 0;


  // agents can be restricted from the dashboard, so hide dashboard shortcuts when their menu has no dashboard entry
  hasDashboardAccess(): boolean {
    const menu = this._local.customGetItem('menu');
    if (!menu || !menu.length) {
      return true;
    }
    return menu.some((item: any) => item.path && item.path.includes('dashboard'));
  }

  // heading is optional -- callers that need their own title (e.g. 'Date Unavailable') pass it,
  // everything else keeps the default Error / Warning / Success heading.
  customPopups(message: string, flag: Number, heading?: string) {
    if (flag == 1) {
      this._toaster.showToaster(heading || 'Error', message, 'error');
    } else if (flag == 2) {
      this._toaster.showToaster(heading || 'Warning', message, 'warning');
    } else {
      this._toaster.showToaster(heading || 'Success', message, 'success');
    }
  }

  hideAllToasters() {
    this._toaster.hideAllToasters();
  }

  crypto(tokenFromUI: string) {
    return md5(tokenFromUI);
  }

  updateMasking(format: '') {
    return format.replace(/#/g, '0');
  }

  guid() {
    const a = new Date();
    const nav = window.navigator;
    const screen = window.screen;
    let guid = nav.mimeTypes.length.toString();
    guid += nav.userAgent.replace(/\D+/g, '');
    guid += nav.plugins.length;
    guid += screen.height || '';
    guid += screen.width || '';
    guid += screen.pixelDepth || '';
    guid += a.getTime();
    return guid;
  }

  device_id() {
    if (!this._local.customGetItem('user')) {
      const guidLog = this.guid();
      this._local.customSetItem('user', guidLog);
    }
  }

  getCurrentTimezone() {
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + time % 60).slice(-2);
    let user_timezone = '';
    if (time > 0) {
      user_timezone = "-" + hours + minutes;
    } else {
      user_timezone = "+" + hours + minutes;
    }
    return user_timezone;
  }

  async base64ToBlob(base64String: string) {
    const dataURI = base64String;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    return blob;
  }

  sortByFun(data: Array<[]>, key_sort_by: string): [][] {
    this.key_sort_by = key_sort_by;
    let sortedData: any;
    if (data) {
      sortedData = data.sort((a: any, b: any) => a[key_sort_by] - b[key_sort_by]);
    }
    return sortedData;
  }

  compare(a: any, b: any) {
    if (a && a[this.key_sort_by] < b && b[this.key_sort_by])
      return -1;
    if (a && a[this.key_sort_by] > b && b[this.key_sort_by])
      return 1;
    return 0;
  }

  updatePanelLanguage(lan_code: string) {
    const value = `/en/${lan_code}`;
    this._local.customSetItem('lan_code', lan_code);
    if (this._local.getCookie('googtrans') && this._local.getCookie('googtrans') == value) {
      return;
    }
    const anchorElement = document.querySelector(`a[data-gt-lang="${lan_code}`);
    setTimeout(() => {
      if (anchorElement instanceof HTMLElement) {
        anchorElement.click();
      }
    }, 1000);
  }

  // Check if the date is valid
  isValidDate(dobData: dobData): boolean {
    if (!dobData) {
      return false;
    }
    const monthNum = parseInt(dobData.month, 10);
    const dayNum = parseInt(dobData.day, 10);
    const yearNum = parseInt(dobData.year, 10);

    // Create a date object
    const date = new Date(yearNum, monthNum - 1, dayNum);

    // Check if the date object matches the input date
    const dates = date.getFullYear() === yearNum && date.getMonth() === monthNum - 1 && date.getDate() === dayNum;
    return dates;
  }

  restrictSpaces(value: string) {
    return value.replace(/\s+/g, ''); // Replace all spaces
  }

  isWeekend(date: Date) {
    const day = date.getDay();
    return (day === 6 || day === 0); // 6 is Saturday, 0 is Sunday
  }

  covertDateTimesAgo(sent_date: any) {
    let date = new Date(sent_date);
    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    if (seconds < 5) {
      return "just now";
    } else if (seconds < 60) {
      return seconds + " seconds ago";
    }
    else if (seconds < 3600) {
      var minutes = Math.floor(seconds / 60)
      if (minutes > 1)
        return minutes + " minutes ago";
      else
        return "1 minute ago";
    }
    else if (seconds < 86400) {
      var hours = Math.floor(seconds / 3600)
      if (hours > 1)
        return hours + " hours ago";
      else
        return "1 hour ago";
    }
    //2 days and no more
    else if (seconds < 172800) {
      var days = Math.floor(seconds / 86400)
      if (days > 1)
        return days + " days ago";
      else
        return "1 day ago";
    }
    else {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? 0 + minutes : minutes;
      return months[date.getMonth()] + " " + date.getDate().toString() + " at " + ('0' + hours).slice(-2) + ":" + ('0' + minutes).slice(-2) + ampm;
    }
  }

  ssncustomValidator(value: string): boolean {
    // Your validation logic goes here
    const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779', '123456789', '012345678', '000000000', '111111111'];
      
     
    if (value && (value.trim().length != 9 || value.slice(5, 9) == "0000" || value.slice(3, 5) == "00" || /^(.)\1+$/.test(value) || /[a-zA-Z]/.test(value) || value.slice(0, 3) == "000" || value.slice(0, 3) == "666" || invalid_ssn.indexOf(value) >= 0 || value == "9876543210" || parseInt(value) >= 987654320 && parseInt(value) <= 987654329)){
      return true;
    }
    return false;
  }
  initIntercom() {
    const userData = this._local.customGetItem('userProfileData');
    if (userData) {
      // Clarity.setTag('doctor_email', userData ? userData.doctor_email : '');
      // Clarity.identify(userData.doctor_email, userData.doctor_email, userData.doctor_email, userData.doctor_name);
      this.intercomService.initialize({
        // name: userData.doctor_name,
        // email: userData.doctor_email,
        // userId: userData.doctor_id,
        intercom_user_jwt: userData.user_hash_key
      });
    }
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control && control.value && typeof control.value === 'string') {
        const trimmedValue = control.value.trim();
        const hasWhitespace = control.value.includes(' '); // Check if any spaces exist
        const isValid = !hasWhitespace; // Valid if no spaces exist
        return isValid ? null : { whitespace: true }; // Return error object if invalid
      }
      return null; // Return null if no validation is needed
    };
  }

  //Check white space start and end of string
   noWhitespaceStartEndValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const isWhitespace = (control.value || '').trim().length !== (control.value || '').length;
        return isWhitespace ? { whitespace: true } : null;
      };
      
    }
    noLeadingWhitespaceValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value as string;
    
        if (!value) return null;
    
        return value.startsWith(' ')
          ? { leadingWhitespace: true }
          : null;
      };
    }

  setClarity() {
    const userData = this._local.customGetItem('userProfileData');
    // Clarity.setTag('doctor_email', userData ? userData.doctor_email : '');
    // Clarity.identify(userData.doctor_email, userData ? userData.doctor_email : '', userData ? userData.doctor_email : '', userData ? userData.doctor_name : '');
  }

  // updateIntercom(){
  //   const userData = this._local.customGetItem('userProfileData');
  //   if (userData) {
  //     this.intercomService.updateUser({
  //       // name: userData.doctor_name,
  //       // email: userData.doctor_email,
  //       // user_id: userData.doctor_id,
  //       intercom_user_jwt: userData.user_hash_key
  //     });
  //   }
  // }
  public modalTypes = {
    verifyDebt: 'verifyDebt',
    awaitingApproval: 'awaitingApproval',
    consentSucessfull: 'consentSucessfull',
    checkEmail: 'checkEmail',
    allSet: 'allSet',
    pendingApproval: 'pendingApproval',
    outreachRequired : 'outreachRequired',
    revokeOutreach : 'revokeOutreach'
  }
  
}

export const passwordValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    if (!password) {
      return { required: 'Please enter new password.' };
    }

    if (/\s/.test(password)) {
      return { noSpace: 'The password must not contain any spaces.' };
    }
    if (!/.{8,12}/.test(password)) {
      return { minLength: 'Password must be 8–12 characters long.' };
    }
    if (!/[A-Z]/.test(password)) {
      return { uppercase: 'Password must contain at least one uppercase letter (A-Z).' };
    }
    if (!/[a-z]/.test(password)) {
      return { lowercase: 'Password must contain at least one lowercase letter (a-z).' };
    }
    if (!/[0-9]/.test(password)) {
      return { number: 'Password must contain at least one number (0-9).' };
    }
    if (!/[!@#$%^&*]/.test(password)) {
      return { specialChar: 'Password must contain at least one special character (!@#$%^&*).' };
    }

    return null; // ✅ valid
  };
};

export interface dobMask {
  specialCharacters: string[],
  fieldOrder: [
    {
      key: string,
      placeholder: string
    },
    {
      key: string,
      placeholder: string
    },
    {
      key: string,
      placeholder: string
    },
  ]
}

export interface languageData {
  created: string,
  is_active: number,
  lan_code: string,
  lan_name: string,
  original_lan_name: string
}

export interface paymentSourceType {
  brand: string,
  exp_month: number,
  exp_year: number,
  last4: string,
  payment_source_type: number,
  source_id: number
}

export interface languageType {
  lan_code: string,
  lan_name: string,
  original_lan_name: string
}

export interface dobData {
  month: string,
  day: string,
  year: string
}

export interface userProfile {
  doctor_name: string,
  doctor_email: string,
  business_verification_state: string,
  google_id: string,
  business_verification_error_code?: string,
  business_verification_error?: string,
  date_registered?: string;
  realmId?: string;
  doctor_mobile_country_code?: string;
  agent_name?: string;
  agent_email: string,
  agent_mobile_country_code?: string;
  agent_id?: number;
  business_brand_outreach?: number;
}

export interface country_currency_info {
  country?: country,
  currency?: currency[],
  mobile_regex?: string,
  doctor_id?: number,
  identity_document_required?: boolean
}

export interface country {
  country_code: string,
  country_id: number,
  country_name: string,
  country_phone_format: string,
  identity_document_max_length: number,
  identity_document_min_length: number,
  enable_bank: number,
  identity_label: string
  mobile_code: string,
  show_instant_payment_card: number
}

export interface currency {
  currency_id: number,
  display_logo: string,
  currency_code: string,
  currency_name: string,
  exchange_rate: number,
  bank_support_type: string[]
}

export interface bank_details {
  bank_name: string,
  routing_number: string,
  account_number: string,
  account_holder_name: string,
  account_holder_type: string,
}
export interface card_details {
  brand: string;
  fingerprint: string;
  last4: string;
  source_id: number;
  date_added:string;
}

export interface menu {
  menu_id: number,
  menu_name: string,
  menu_enum: string,
  path: string,
  all_restricted_items: string,
  icon: string,
  in_order: number,
  status: string,
  only_path: string,
  parent_id: string,
  created_by: string,
  modified_by: number,
  created_at: string,
  modified_at: string,
  show_to_business: number,
  role_id: number,
  restricted_items: string,
  text: string,
  link: string,
  submenu: [menu]
}

@Pipe({ name: 'currencyFormat' })
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: any, display_logo: any) {
    if (!value) return '';
    const num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]+/g, '')) : value;
    return display_logo +(new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num));
  }
}
@Pipe({ name: 'maskSensitive' })
export class MaskSensitivePipe implements PipeTransform {
  transform(value: string): any {
    if (!value) return value;

    // Regex for emails
    const emailRegex = /([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    // Regex for phone numbers (with optional +country code)
    const phoneRegex = /\+?\d{9,15}/g;

    // Mask emails
    let result = value.replace(emailRegex, (match, localPart, domain) => {
      const hiddenLocalPart = ''.padEnd(localPart.length, 'x');
      return `${hiddenLocalPart}@${domain}`;
    });

    // Mask phone numbers → keep country code + last 3 digits visible
    result = result.replace(phoneRegex, (match) => {
      const countryCodeMatch = match.match(/^\+\d{1,1}/);
      const countryCode = countryCodeMatch ? countryCodeMatch[0] : '';
      const numberPart = match.replace(countryCode, '');

      if (numberPart.length <= 3) return match; // too short to mask

      const visible = numberPart.slice(-3);
      const hidden = ''.padEnd(numberPart.length - 3, 'X');

      return `${countryCode}${hidden}${visible}`;
    });
    return result;
  }
}

@Pipe({
  name: 'phoneMask'
})
export class PhoneMaskPipe implements PipeTransform {
  transform(phone: string | number, mask: string): string {
    if (!phone || !mask) {return ''};
    
    const digits = phone.toString().replace(/\D/g, '');
    let index = 0;
    let result = '';

    for (const char of mask) {
      if (char === '0') {
        if (index < digits.length) {
          result += digits[index++];
        } else {
          break;
        }
      } else {
        result += char;
      }
    }
    return result;
  }
}